import { Empty } from "antd";
import { useNavigate } from "react-router";
import type { ICourseResponse } from "../../../../app/features/courses/courses.types";
import CourseItem from "../../../../components/ui/CourseItem";
import CourseItemSkeleton from "../../../../components/ui/CourseItemSkeleton";

type Props = {
  courses?: ICourseResponse[];
  isLoading?: boolean;
};
export default function CourseList({ courses = [], isLoading }: Props) {
  const navigate = useNavigate();
  // const { limit, page, handlePagination } = useFilters();

  return (
    <section>
      <div className="grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 gap-6 mb-5">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <CourseItemSkeleton key={index} />
          ))
        ) : courses?.length > 0 ? (
          courses?.map((el) => {
            const course = el?.Course;

            return (
              <CourseItem
                key={course?.id}
                img={course?.thumbnailUrl}
                title={course?.title}
                category={course?.Category?.name}
                description={course?.description}
                price={course?.price}
                offerPrice={course?.offerPrice}
                tags={course?.CourseTag?.map((tag) => ({
                  title: tag.Tag?.name,
                  icon: undefined,
                }))}
                id={course?.id}
                onMoreButton={() =>
                  navigate(
                    `${course?.id}/module?title=${encodeURIComponent(course?.title)}`,
                  )
                }
                moreBtnText="কোর্স দেখুন"
                courseUuid={course?.uuid}
              />
            );
          })
        ) : (
          <div className="xl:col-span-3 md:col-span-2 py-5">
            <Empty description="কোর্স সমূহ পাওয়া যায়নি" />
          </div>
        )}
      </div>

      {/* <CustomPagination
        limit={limit}
        page={page}
        total={1}
        handlePagination={handlePagination}
        prevIcon={<LeftPaginationArrowIcon />}
        nextIcon={<RightPaginationArrowIcon />}
        className="border-none"
        paginationClassName="course_pagination pt-4"
        hidePage
      /> */}
    </section>
  );
}
